import firebase from "./src/firebase";
import useAuth from "./src/auth";

export { firebase, useAuth };
export default firebase;
